import React, { useMemo } from 'react'
import PropTypes from 'prop-types'

import { getFormattedListItemObjective } from '../../../../../helpers/componentsHelpers'

import {
  FACEBOOK_PROVIDER_PLATFORM,
  PROVIDER_TO_PLATFORMS,
  TIKTOK_PROVIDER_PLATFORM
} from '../../../../../../constants/selectLists/platformList'

import { LIST_ITEM_LINE_ITEM } from '../../../../../../constants/other'
import { OPTIMIZATION_GOAL } from '../../../../../../forms/Tiktok/UploadTikTokAdCreative/UploadTikTokAdCreativeForm/LineItemForm/fields'

import useStyles from './styles'

const Goal = ({ item, getShowGoal, listItemType }) => {
  const classes = useStyles()

  const { objective, [OPTIMIZATION_GOAL]: optimizationGoal, provider, promoted_object: promotedObject = {} } = item

  const goal = useMemo(() => {
    if (
      listItemType === LIST_ITEM_LINE_ITEM &&
      objective === 'offsite_conversions' &&
      provider === FACEBOOK_PROVIDER_PLATFORM
    ) {
      if (promotedObject.custom_event_type === 'OTHER') {
        return promotedObject.custom_event_str
      } else if (promotedObject.custom_event_type) {
        return promotedObject.custom_event_type
      } else {
        return objective
      }
    } else if (listItemType === LIST_ITEM_LINE_ITEM && provider === TIKTOK_PROVIDER_PLATFORM) {
      return optimizationGoal
    } else {
      return objective
    }
  }, [
    listItemType,
    objective,
    promotedObject.custom_event_type,
    promotedObject.custom_event_str,
    provider,
    optimizationGoal
  ])

  if (!goal) return null

  if (typeof getShowGoal === 'function' && !getShowGoal(provider)) {
    return null
  }

  return <p className={classes.goal}>Goal: {getFormattedListItemObjective(PROVIDER_TO_PLATFORMS[provider], goal)}</p>
}

Goal.propTypes = {
  item: PropTypes.object.isRequired,
  getShowGoal: PropTypes.func,
  listItemType: PropTypes.string
}

export default Goal
